// [CMS-VERSION: 1.1.0-Hardened]
import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import { apiUrl } from '../lib/apiBase';

const CMSContext = createContext();

export const useCMS = () => useContext(CMSContext);

// ... (defaultData remains the same)

const defaultData = {
  hero: {
    desktopBanner: "https://phlebo-india.s3.ap-south-1.amazonaws.com/curelo-health/hero.png",
    mobileBanner: "https://phlebo-india.s3.ap-south-1.amazonaws.com/curelo-health/mob.png",
    smallBanner: "https://phlebo-india.s3.ap-south-1.amazonaws.com/curelo-health/small-ban.png",
    heroHeading: "Your Health, {Our Priority}",
    heroDescription: "Experience accurate diagnostics, on-time collections, and reliable care tailored for you.",
    offerTitle: "Get Report Consultation & Diet Plan",
    offerSubtitle: "with your Booking!",
    offerPriceOriginal: "₹799",
    formTitle: "Book Your Test Today",
    uspsTitle: "Why Choose Curelo Health?",
    usps: [
      { icon: 'https://phlebo-india.s3.ap-south-1.amazonaws.com/curelo-health/icon1.png', title: "100% Honest Pricing" },
      { icon: 'https://phlebo-india.s3.ap-south-1.amazonaws.com/curelo-health/icon2.png', title: "India's Widest Home Collection Network" },
      { icon: 'https://phlebo-india.s3.ap-south-1.amazonaws.com/curelo-health/icon3.png', title: "100% Report Accuracy Guaranteed" },
      { icon: 'https://phlebo-india.s3.ap-south-1.amazonaws.com/curelo-health/icon4.png', title: "70+ Lakhs Patients Served" }
    ],
    showHeroContent: true
  },
  formData: {
    cities: ["Delhi", "Noida", "Gurgaon", "Ghaziabad", "Faridabad", "Vadodara", "Ahmedabad"],
    otpEnabled: false,
    otpExpiryMinutes: 5,
    otpMaxRetries: 3,
    otpResendCooldownSeconds: 30,
    otpMaxResends: 3
  },
  kwikForm: {
    enabled: true,
    containerId: "kf-form",
    minHeight: "350",
    maxHeight: "550",
    minHeightMobile: "500",
    maxHeightMobile: "1400"
  },
  testDetails: {
    description: "Your body gives signals before a problem becomes serious—are you paying attention? This package helps you catch early signs of health issues so you can take action on time. It includes 68 important tests to check your liver, kidney, blood health, and more—giving you a complete health update with a single test. Curelo Health is among the most trusted pathology labs near you, offering affordable health packages and accurate diagnostics. Whether you're looking for laboratories near me or a nearby pathology center, our experts ensure quick home sample collection and accurate digital report delivery.",
    bannerImage: "https://phlebo-india.s3.ap-south-1.amazonaws.com/curelo-health/test.png",
    cards: [
      { title: "Get Reports in", value: "15 Hours", sub: "Get Reports in" },
      { title: "Fasting Requirement", value: "10-12 Hrs fasting Required", sub: "Fasting Requirement" },
      { title: "Home Collection", value: "Available", sub: "Home Collection" },
      { title: "Age Group", value: "5-99", sub: "Age Group" }
    ]
  },
  mostBookedPackages: {
    title: "Our Most Booked Packages",
    subtitle: "Comprehensive health checkups for your wellness",
    packages: [
      {
        title: "Fit India Full Body Checkup with Free HbA1c",
        includes: "90 Parameters",
        reportTime: "12 hours",
        price: "₹1249",
        originalPrice: "₹5947",
        discount: "78% OFF",
        recommended: false,
        tags: ["HbA1c", "Lipid", "Liver", "Kidney"],
        extraTags: ["Infection", "Thyroid"],
        catalogId: "",
        itemType: ""
      },
      {
        title: "Fit India Full Body with Vitamin Screening & Heart Test",
        includes: "96 Parameters",
        reportTime: "12 hours",
        price: "₹1799",
        originalPrice: "₹8566",
        discount: "78% OFF",
        recommended: true,
        tags: ["Heart", "HbA1c", "Lipid", "Liver"],
        extraTags: ["Kidney", "Infection"],
        catalogId: "",
        itemType: ""
      },
      {
        title: "Advance Plus Full Body Checkup",
        includes: "100 Parameters",
        reportTime: "12 hours",
        price: "₹2499",
        originalPrice: "₹9955",
        discount: "74% OFF",
        recommended: false,
        tags: ["Heart", "HbA1c", "Lipid", "Liver"],
        extraTags: ["Kidney", "Infection"],
        catalogId: "",
        itemType: ""
      }
    ]
  },
  whyChooseUs: {
    title: "Why Book Tests With us ?",
    subtitle: "Trusted by 90 Lakhs+ satisfied customers",
    features: [
      { icon: "FiCheckCircle", title: "Quality", description: "Follow Stringent Quality Control" },
      { icon: "FiClock", title: "On-Time Services", description: "Sample Collection & Reports" },
      { icon: "FiThumbsUp", title: "Convenience", description: "At-Home & In-Lab Services" },
      { icon: "FiCalendar", title: "Availability", description: "365 days a year" }
    ]
  },
  faqs: {
    title: "Frequently Asked Questions",
    subtitle: "Find answers to common questions about our services",
    image: "https://phlebo-india.s3.ap-south-1.amazonaws.com/curelo-health/Shreyas.png",
    items: [
      {
        question: "How does the home sample collection work?",
        answer: "Once you book a test, a certified phlebotomist will visit your home at your scheduled time to collect samples. The service is free of cost."
      },
      {
        question: "Which labs are affiliated with Curelo?",
        answer: "We partner with over 1500+ top NABL certified labs across India to ensure you get the most accurate and reliable diagnostic services."
      },
      {
        question: "Do you serve in Delhi/NCR?",
        answer: "Yes, we have extensive coverage across Delhi, Noida, Gurgaon, Ghaziabad, and Faridabad with multiple collection centers."
      },
      {
        question: "How soon will I get my reports?",
        answer: "Reports are typically generated within 12-24 hours depending on the test, and are delivered digitally via Email or WhatsApp."
      }
    ]
  },
  contact: {
    phone: '+918069770000',
    whatsapp: '918069770000',
    whatsappMessage: 'Hi, I need help finding a health package.'
  }
};

const API_URL = apiUrl('/api/cms');

const isAdminPath = () =>
  typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');

const getSlugFromPath = () => {
  if (typeof window === 'undefined') return 'home';
  const slug = window.location.pathname.replace(/^\/+|\/+$/g, '');
  return slug || 'home';
};

const buildPageStub = (page) => ({
  slug: page.slug,
  title: page.title,
  template: page.template || 'default',
  data: null,
});

const derivePageOrder = (pages, preferredOrder) => {
  const order = (preferredOrder || []).filter((slug) => pages?.[slug]);
  const known = new Set(order);
  Object.keys(pages || {}).forEach((slug) => {
    if (!known.has(slug)) order.push(slug);
  });
  return order;
};

// CloudFront rewrites API 404s into the SPA index.html (HTML body, status 200).
// This helper returns parsed JSON, or null when the body is not JSON (e.g. that
// HTML fallback), so callers can treat it as "not found" instead of crashing on
// Response.json()'s "Unexpected token '<'".
const readJsonResponse = async (response) => {
  const contentType = response.headers.get('content-type') || '';
  const text = await response.text();
  const trimmed = text.trimStart();
  const looksJson =
    contentType.includes('application/json') || trimmed.startsWith('{') || trimmed.startsWith('[');
  if (!looksJson) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
};

const normalizeLoadedPage = (page) => {
  if (!page) return null;
  return {
    ...page,
    template: page.template || 'default',
    data: deepMerge(defaultData, page.data || {}),
  };
};

const deepMerge = (target, source) => {
  if (!source) return target;
  const merged = { ...target };
  Object.keys(source).forEach(key => {
    if (source[key] instanceof Object && !Array.isArray(source[key])) {
      merged[key] = deepMerge(target[key] || {}, source[key]);
    } else {
      merged[key] = source[key];
    }
  });
  return merged;
};

const compressImage = (base64Str, maxWidth = 1000, quality = 0.5) => {
  if (!base64Str || typeof base64Str !== 'string' || !base64Str.startsWith('data:image')) return Promise.resolve(base64Str);

  const originalSize = base64Str.length;

  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;

      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width);
        width = maxWidth;
      }

      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);

      const result = canvas.toDataURL('image/jpeg', quality);
      console.log(`[CMS] Compressed image: ${(originalSize / 1024).toFixed(1)}KB -> ${(result.length / 1024).toFixed(1)}KB`);
      resolve(result);
    };
    img.onerror = () => {
      // CRITICAL: If image is invalid AND large, sending the original will cause a 413.
      // We drop the corrupt image to save the payload if it's > 500KB.
      if (originalSize > 500 * 1024) {
        console.warn(`[CMS] Found invalid/corrupt oversized image (${(originalSize / 1024).toFixed(1)}KB). Clearing it to prevent 413 error.`);
        // Return a tiny 1x1 transparent pixel instead of the 11MB junk
        resolve('data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
      } else {
        console.warn('[CMS] Failed to load small image for compression, sending original.');
        resolve(base64Str);
      }
    };
  });
};

const cleanState = (data) => {
  if (!data || !data.pages) return data;
  const cleanedPages = {};
  Object.keys(data.pages).forEach(slug => {
    const page = data.pages[slug];
    cleanedPages[slug] = {
      ...page,
      data: deepMerge(defaultData, page.data || {})
    };
  });

  if (!cleanedPages.home) {
    cleanedPages.home = {
      title: 'Home Page',
      slug: 'home',
      template: 'default',
      data: defaultData
    };
  }

  // Hardening: Clean any top-level junk properties (like deleteSlug)
  const topLevelKeys = Object.keys(data);
  const validTopLevelKeys = ['pages', 'activePageSlug', 'pageOrder'];
  const cleanedData = { ...data };
  topLevelKeys.forEach(key => {
    if (!validTopLevelKeys.includes(key)) {
      console.warn(`[CMS] Removing junk property from state: ${key}`);
      delete cleanedData[key];
    }
  });

  return {
    ...cleanedData,
    pages: cleanedPages,
    pageOrder: derivePageOrder(cleanedPages, cleanedData.pageOrder),
    activePageSlug: cleanedData.activePageSlug || 'home'
  };
};

const compressStateImages = async (data) => {
  const result = JSON.parse(JSON.stringify(data)); // Deep clone

  const processObject = async (obj) => {
    for (const key in obj) {
      if (typeof obj[key] === 'string' && obj[key].startsWith('data:image')) {
        obj[key] = await compressImage(obj[key]);
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        await processObject(obj[key]);
      }
    }
  };

  await processObject(result);
  return result;
};

export const CMSProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [pageNotFound, setPageNotFound] = useState(false);
  const [saving, setSaving] = useState(false);
  const [state, setState] = useState(() => {
    const initialSlug = getSlugFromPath();
    const publicInitialState = {
      pages: {
        [initialSlug]: {
          title: 'Loading...',
          slug: initialSlug,
          template: 'default',
          data: null,
        },
      },
      activePageSlug: initialSlug,
    };

    if (!isAdminPath()) {
      return publicInitialState;
    }

    const initialState = {
      pages: {
        home: {
          title: 'Home Page',
          slug: 'home',
          template: 'default',
          data: defaultData
        }
      },
      pageOrder: ['home'],
      activePageSlug: 'home'
    };

    try {
      const savedData = localStorage.getItem('curelo_multi_cms_data');
      if (savedData) {
        const parsed = JSON.parse(savedData);
        if (!parsed || !parsed.pages) return initialState;

        // Ensure all pages have the latest default sections
        const mergedPages = {};
        Object.keys(parsed.pages).forEach(slug => {
          mergedPages[slug] = {
            ...parsed.pages[slug],
            template: parsed.pages[slug].template || 'default',
            data: {
              ...defaultData,
              ...parsed.pages[slug].data
            }
          };
        });
        return {
          ...parsed,
          pages: mergedPages,
          pageOrder: derivePageOrder(mergedPages, parsed.pageOrder),
          activePageSlug: parsed.activePageSlug || 'home'
        };
      }

      // Migration from old single-page format
      const oldData = localStorage.getItem('curelo_cms_data');
      if (oldData) {
        const parsed = JSON.parse(oldData);
        if (!parsed) return initialState;

        return {
          pages: {
            home: {
              title: 'Home Page',
              slug: 'home',
              template: 'default',
              data: {
                ...defaultData,
                ...parsed,
                hero: { ...defaultData.hero, ...parsed.hero },
                testDetails: { ...defaultData.testDetails, ...parsed.testDetails },
                mostBookedPackages: { ...defaultData.mostBookedPackages, ...parsed.mostBookedPackages },
                whyChooseUs: { ...defaultData.whyChooseUs, ...parsed.whyChooseUs || {} },
                faqs: { ...defaultData.faqs, ...parsed.faqs || {} },
                contact: { ...defaultData.contact, ...parsed.contact || {} },
                formData: { ...defaultData.formData, ...parsed.formData || {} }
              }
            }
          },
          pageOrder: ['home'],
          activePageSlug: 'home'
        };
      }
    } catch (error) {
      console.error('Error initializing CMS state from localStorage:', error);
    }

    return initialState;
  });

  const fetchPageIntoState = useCallback(async (slug) => {
    const normalizedSlug = slug || 'home';
    setPageLoading(true);
    try {
      const response = await fetch(`${API_URL}/${encodeURIComponent(normalizedSlug)}`);
      if (response.status === 404) {
        setPageNotFound(true);
        return { success: false, notFound: true };
      }
      if (!response.ok) {
        throw new Error(`Server returned ${response.status}`);
      }

      const result = await readJsonResponse(response);
      // CloudFront can rewrite a backend 404 into index.html with status 200.
      if (!result) {
        setPageNotFound(true);
        return { success: false, notFound: true };
      }
      const page = result.page;
      if (!page) {
        throw new Error('Invalid page response');
      }

      const normalized = normalizeLoadedPage(page);

      setState((prev) => ({
        ...prev,
        pages: {
          ...prev.pages,
          [normalizedSlug]: {
            ...(prev.pages[normalizedSlug] || {}),
            ...normalized,
          },
        },
      }));
      setPageNotFound(false);

      return { success: true };
    } catch (error) {
      console.error(`[CMS] Failed to load page "${normalizedSlug}":`, error);
      return { success: false, error: error.message };
    } finally {
      setPageLoading(false);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;

    const attemptAdminLoad = async () => {
      // The admin dashboard now loads the page index lazily, page-by-page,
      // via /api/cms/pages with pagination. The shared CMS context only needs
      // enough state to support direct page editing on demand.
      return {
        stubs: {
          home: buildPageStub({ slug: 'home', title: 'Home Page', template: 'default' }),
        },
        pageOrder: ['home'],
        resolvedActiveSlug: 'home',
      };
    };

    // Landing pages render exactly one slug per document load — nothing on them
    // links to another CMS page client-side — so they never need the page
    // index. That matters because GET /api/cms returns every page's full data,
    // inlined images and all (megabytes), while the single-page endpoint is a
    // few KB. Fetching only the page is what the visitor waits on.
    const attemptPublicLoad = async (initialSlug) => {
      const response = await fetch(`${API_URL}/${encodeURIComponent(initialSlug)}`);
      if (response.status === 404) return { notFound: true };
      if (!response.ok) throw new Error(`Server returned ${response.status}`);

      // Null body = CloudFront served index.html for a backend 404.
      const result = await readJsonResponse(response);
      const loaded = result?.page ? normalizeLoadedPage(result.page) : null;
      if (!loaded) return { notFound: true };

      return { page: loaded };
    };

    // cms-backend runs on Cloud Run at min-instances 0 — the very first
    // request after any period of inactivity can be slow enough to fail or
    // time out while the container cold-starts. Without a retry, that
    // leaves the admin dashboard stuck on the synchronous fallback state
    // (a single "Home Page" stub — see the useState initializer above)
    // with nothing to recover it short of a manual refresh, which only
    // works because it happens to hit the now-warm backend. A short retry
    // loop here self-heals within a few seconds instead.
    const MAX_ATTEMPTS = 3;
    const RETRY_DELAY_MS = 1500;

    const initCMS = async () => {
      const initialSlug = getSlugFromPath();
      const onAdminPath = isAdminPath();
      console.log(
        onAdminPath ? '[CMS] Loading page index...' : `[CMS] Loading page "${initialSlug}"...`,
      );

      for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt += 1) {
        try {
          if (onAdminPath) {
            const { stubs, pageOrder, resolvedActiveSlug } = await attemptAdminLoad();
            if (cancelled) return;
            setState({
              pages: stubs,
              pageOrder,
              activePageSlug: resolvedActiveSlug,
            });
          } else {
            const { page, notFound } = await attemptPublicLoad(initialSlug);
            if (cancelled) return;
            setPageNotFound(Boolean(notFound));
            if (page) {
              setState((prev) => ({
                ...prev,
                pages: { ...prev.pages, [initialSlug]: page },
                activePageSlug: initialSlug,
              }));
            }
          }
          setHasError(false);
          return;
        } catch (error) {
          console.error(
            `[CMS] Failed to fetch CMS data (attempt ${attempt}/${MAX_ATTEMPTS}):`,
            error,
          );
          if (attempt === MAX_ATTEMPTS) {
            if (!cancelled) setHasError(true);
            return;
          }
          await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
        }
      }
    };

    initCMS().finally(() => {
      if (!cancelled) setLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  // Admin-only localStorage backup (debounced — avoids blocking the main thread on every keystroke)
  useEffect(() => {
    if (!isAdminPath() || loading) return undefined;

    const timer = setTimeout(() => {
      try {
        localStorage.setItem('curelo_multi_cms_data', JSON.stringify(state));
      } catch (error) {
        if (error.name === 'QuotaExceededError' || error.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
          console.warn('CMS backup storage limit reached (likely due to large images). Changes are only saved in session memory until you Publish.');
        } else {
          console.error('Failed to save CMS data to localStorage:', error);
        }
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [state, loading]);

  const saveToServer = useCallback(async (dataToSave = state, forceFull = false) => {
    setSaving(true);
    console.log('[CMS] Starting Save sequence...');
    try {
      let payload;
      let isPartial = false;

      // Determine if we should do a partial update (current page only)
      if (!forceFull && dataToSave.activePageSlug && dataToSave.pages[dataToSave.activePageSlug]) {
        console.log(`[CMS] Preparing partial payload for: ${dataToSave.activePageSlug}`);
        const activePage = dataToSave.pages[dataToSave.activePageSlug];

        // Clean and compress ONLY the active page
        const cleanedActivePage = {
          ...activePage,
          data: deepMerge(defaultData, activePage.data || {})
        };

        // Compress images recursively in the single page data
        const processObject = async (obj) => {
          for (const key in obj) {
            if (typeof obj[key] === 'string' && obj[key].startsWith('data:image')) {
              obj[key] = await compressImage(obj[key]);
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
              await processObject(obj[key]);
            }
          }
        };
        await processObject(cleanedActivePage.data);

        payload = JSON.stringify(cleanedActivePage);
        isPartial = true;
      } else {
        console.log('[CMS] Preparing full site payload...');
        const cleaned = cleanState(dataToSave);
        const compressed = await compressStateImages(cleaned);
        payload = JSON.stringify(compressed);
      }

      console.log(`[CMS] Final payload size: ${(payload.length / 1024).toFixed(1)}KB (${isPartial ? 'Partial' : 'Full'})`);

      if (payload.length > 4 * 1024 * 1024) {
        console.warn(`[CMS] Payload is still large (${(payload.length / 1024 / 1024).toFixed(2)}MB). Attempting to proceed...`);
      }

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: payload,
      });

      if (response.status === 413) {
        throw new Error('Total website size is still too large even after compression! This is unexpected with partial updates. Please contact support.');
      }

      if (!response.ok) {
        const errorText = await response.text();
        let errorMessage = 'Failed to save';
        try {
          const errorData = JSON.parse(errorText);
          errorMessage = errorData.error || errorData.message || errorMessage;
        } catch (e) {
          errorMessage = `Server error (${response.status})`;
        }
        throw new Error(errorMessage);
      }

      // 3. Update local state with the cleaned and compressed version
      if (isPartial) {
        setState(prev => ({
          ...prev,
          pages: {
            ...prev.pages,
            [dataToSave.activePageSlug]: JSON.parse(payload) // payload is the stringified page
          }
        }));
      } else {
        setState(JSON.parse(payload));
      }

      console.log('[CMS] Save successful!');
      return { success: true };
    } catch (error) {
      console.error('[CMS] Save failed:', error);
      return { success: false, error: error.message || 'An unexpected error occurred' };
    } finally {
      setSaving(false);
    }
  }, [state]);

  const activePage = (state.pages && state.pages[state.activePageSlug])
    || (state.pages && state.pages['home'])
    || { title: 'Home', slug: 'home', template: 'default', data: null };

  const isPageContentLoaded = Boolean(activePage?.data?.hero);

  const data = activePage?.data?.hero
    ? deepMerge(defaultData, activePage.data)
    : defaultData;

  const setActivePage = useCallback((slug) => {
    console.log(`[CMS] Setting active page to: ${slug}`);
    setState((prev) => {
      // Public loads never fetch the page index, so a slug can legitimately be
      // unknown here — stub it and let the fetch below decide 200 vs 404.
      if (!prev.pages[slug]) {
        fetchPageIntoState(slug);
        return {
          ...prev,
          pages: { ...prev.pages, [slug]: buildPageStub({ slug, title: 'Loading...' }) },
          activePageSlug: slug,
        };
      }
      if (!prev.pages[slug]?.data?.hero) {
        fetchPageIntoState(slug);
      }
      if (prev.activePageSlug === slug) {
        return prev;
      }
      return { ...prev, activePageSlug: slug };
    });
  }, [fetchPageIntoState]);

  const createPage = useCallback((slug, title, template = 'default') => {
    return true;
  }, [state.pages]);

  const createPageAndSave = useCallback(async (slug, title, template = 'default') => {
    if (state.pages[slug]) return { success: false, error: 'A page with this slug already exists' };

    console.log(`[CMS] Creating and saving new page: ${slug}`);

    // 1. Prepare the new page object
    const newPage = {
      title,
      slug,
      template,
      data: defaultData
    };

    // 2. Prepare the payload for a partial update
    // Note: The server handles { slug, data, title, template } as a partial update
    const payload = JSON.stringify(newPage);

    setSaving(true);
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: payload,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Server error (${response.status})`);
      }

      // 3. Update local state only after successful server save
      setState(prev => ({
        ...prev,
        pages: {
          ...prev.pages,
          [slug]: newPage
        },
        pageOrder: prev.pageOrder?.includes(slug) ? prev.pageOrder : [...(prev.pageOrder || []), slug],
        activePageSlug: slug // Auto-select the new page
      }));

      console.log(`[CMS] Page "${slug}" created and saved successfully.`);
      return { success: true };
    } catch (error) {
      console.error('[CMS] Create and save failed:', error);
      return { success: false, error: error.message || 'Failed to save new page to server' };
    } finally {
      setSaving(false);
    }
  }, [state.pages]);

  const updatePageTemplate = useCallback((slug, template) => {

    setState(prev => ({
      ...prev,
      pages: {
        ...prev.pages,
        [slug]: {
          ...prev.pages[slug],
          template
        }
      }
    }));
  }, []);

  const updatePageTemplateAndSave = useCallback(async (slug, template) => {
    const page = state.pages[slug];
    if (!page) return { success: false, error: 'Page not found' };

    setSaving(true);
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          slug,
          title: page.title,
          template,
          data: page.data,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Server error (${response.status})`);
      }

      setState(prev => ({
        ...prev,
        pages: {
          ...prev.pages,
          [slug]: { ...prev.pages[slug], template },
        },
      }));

      return { success: true };
    } catch (error) {
      console.error('[CMS] Template save failed:', error);
      return { success: false, error: error.message || 'Failed to save template' };
    } finally {
      setSaving(false);
    }
  }, [state.pages]);

  const deletePage = useCallback((slug) => {
    if (slug === 'home') return false;

    setState(prev => {
      const newPages = { ...prev.pages };
      delete newPages[slug];
      return {
        ...prev,
        pages: newPages,
        pageOrder: (prev.pageOrder || []).filter((s) => s !== slug),
        activePageSlug: prev.activePageSlug === slug ? 'home' : prev.activePageSlug
      };
    });
    return true;
  }, []);

  const deletePageAndSave = useCallback(async (slug) => {
    if (slug === 'home') return { success: false, error: 'Cannot delete home page' };

    setSaving(true);
    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ deleteSlug: slug }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        let errorMessage = 'Failed on server';
        let isNotFound = response.status === 404;
        try {
          const errorData = JSON.parse(errorText);
          errorMessage = errorData.error || errorData.message || errorMessage;
        } catch (e) {
          errorMessage = `Server error (${response.status})`;
        }

        // If page is not found on server, we should still proceed with local deletion
        // to stay in sync if the server data was lost or manually edited.
        if (isNotFound) {
          console.warn(`[CMS] Page "${slug}" not found on server. Proceeding with local removal.`);
        } else {
          throw new Error(errorMessage);
        }
      }

      // Update local state after successful server deletion
      setState(prev => {
        const newPages = { ...prev.pages };
        delete newPages[slug];
        return {
          ...prev,
          pages: newPages,
          pageOrder: (prev.pageOrder || []).filter((s) => s !== slug),
          activePageSlug: prev.activePageSlug === slug ? 'home' : prev.activePageSlug
        };
      });

      console.log(`[CMS] Page "${slug}" deleted successfully.`);
      return { success: true };
    } catch (error) {
      console.error('[CMS] Deletion failed:', error);
      return { success: false, error: error.message || 'An unexpected error occurred' };
    } finally {
      setSaving(false);
    }
  }, []);

  const duplicatePageAndSave = useCallback(async (sourceSlug, newSlug, newTitle, template) => {
    if (state.pages[newSlug]) return { success: false, error: 'A page with this slug already exists' };

    setSaving(true);
    try {
      const fetchResponse = await fetch(`${API_URL}/${encodeURIComponent(sourceSlug)}`);
      if (!fetchResponse.ok) {
        return { success: false, error: 'Source page not found' };
      }

      const { page } = await fetchResponse.json();
      const normalized = normalizeLoadedPage(page);
      if (!normalized?.data) {
        return { success: false, error: 'Invalid source page data' };
      }

      const resolvedTemplate = template || normalized.template || 'default';
      console.log(`[CMS] Duplicating page "${sourceSlug}" to "${newSlug}" with template "${resolvedTemplate}"`);

      const newPage = {
        title: newTitle,
        slug: newSlug,
        template: resolvedTemplate,
        data: JSON.parse(JSON.stringify(normalized.data)),
      };

      const payload = JSON.stringify(newPage);

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: payload,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Server error (${response.status})`);
      }

      // 3. Update local state only after successful server save
      setState(prev => ({
        ...prev,
        pages: {
          ...prev.pages,
          [newSlug]: newPage
        },
        pageOrder: prev.pageOrder?.includes(newSlug) ? prev.pageOrder : [...(prev.pageOrder || []), newSlug],
        activePageSlug: newSlug // Auto-select the duplicated page
      }));

      console.log(`[CMS] Page "${newSlug}" duplicated and saved successfully.`);
      return { success: true };
    } catch (error) {
      console.error('[CMS] Duplication failed:', error);
      return { success: false, error: error.message || 'Failed to save duplicated page to server' };
    } finally {
      setSaving(false);
    }
  }, [state.pages]);

  const getAllPages = useCallback(() => {
    const order = state.pageOrder?.length
      ? state.pageOrder.filter((slug) => state.pages[slug])
      : Object.keys(state.pages);

    const known = new Set(order);
    Object.keys(state.pages).forEach((slug) => {
      if (!known.has(slug)) order.push(slug);
    });

    return order.map((slug) => {
      const page = state.pages[slug];
      return { title: page.title, slug: page.slug, template: page.template };
    });
  }, [state.pages, state.pageOrder]);

  const updateSection = useCallback((section, newData) => {
    setState(prev => {
      const currentPage = prev.pages[prev.activePageSlug];
      return {
        ...prev,
        pages: {
          ...prev.pages,
          [prev.activePageSlug]: {
            ...currentPage,
            data: {
              ...currentPage.data,
              [section]: { ...currentPage.data[section], ...newData }
            }
          }
        }
      };
    });
  }, []);

  const updateSectionAndSave = useCallback(async (section, newData) => {
    const currentPage = state.pages[state.activePageSlug];
    const nextState = {
      ...state,
      pages: {
        ...state.pages,
        [state.activePageSlug]: {
          ...currentPage,
          data: {
            ...currentPage.data,
            [section]: { ...currentPage.data[section], ...newData }
          }
        }
      }
    };

    setState(nextState);

    // Use the newly calculated state for saving
    return await saveToServer(nextState);
  }, [state, saveToServer]);

  // Merges ALL sections of a page's local draft (e.g. AdminPage's localData —
  // hero, mostBookedPackages, whyChooseUs, faqs, formData, etc., all at once)
  // rather than just one, then saves. updateSectionAndSave above only merges
  // the single section it's given, so if a user edits several admin tabs
  // before hitting "Save & Publish", only the tab active at save-time would
  // be persisted — every other tab's edits would be silently discarded, since
  // saveToServer's partial-update path re-syncs local state to whatever this
  // save call sent. AdminPage's "Save & Publish" must go through this
  // function instead so a save from any tab carries every tab's edits.
  const updateAllSectionsAndSave = useCallback(async (fullPageData) => {
    const currentPage = state.pages[state.activePageSlug];
    const nextState = {
      ...state,
      pages: {
        ...state.pages,
        [state.activePageSlug]: {
          ...currentPage,
          data: { ...currentPage.data, ...fullPageData }
        }
      }
    };

    setState(nextState);

    return await saveToServer(nextState);
  }, [state, saveToServer]);

  const updateUSP = useCallback((index, field, value) => {
    setState(prev => {
      const currentPage = prev.pages[prev.activePageSlug];
      const newUSPs = [...currentPage.data.hero.usps];
      newUSPs[index] = { ...newUSPs[index], [field]: value };
      return {
        ...prev,
        pages: {
          ...prev.pages,
          [prev.activePageSlug]: {
            ...currentPage,
            data: {
              ...currentPage.data,
              hero: { ...currentPage.data.hero, usps: newUSPs }
            }
          }
        }
      };
    });
  }, []);

  const updateTestCard = useCallback((index, field, value) => {
    setState(prev => {
      const currentPage = prev.pages[prev.activePageSlug];
      const newCards = [...currentPage.data.testDetails.cards];
      newCards[index] = { ...newCards[index], [field]: value };
      return {
        ...prev,
        pages: {
          ...prev.pages,
          [prev.activePageSlug]: {
            ...currentPage,
            data: {
              ...currentPage.data,
              testDetails: { ...currentPage.data.testDetails, cards: newCards }
            }
          }
        }
      };
    });
  }, []);

  const updatePackage = useCallback((index, field, value) => {
    setState(prev => {
      const currentPage = prev.pages[prev.activePageSlug];
      const newPackages = [...currentPage.data.mostBookedPackages.packages];
      newPackages[index] = { ...newPackages[index], [field]: value };
      return {
        ...prev,
        pages: {
          ...prev.pages,
          [prev.activePageSlug]: {
            ...currentPage,
            data: {
              ...currentPage.data,
              mostBookedPackages: { ...currentPage.data.mostBookedPackages, packages: newPackages }
            }
          }
        }
      };
    });
  }, []);

  return (
    <CMSContext.Provider value={{
      data,
      activePageSlug: state.activePageSlug,
      activeTemplate: activePage.template,
      setActivePage,
      createPage,
      createPageAndSave,
      updatePageTemplate,
      updatePageTemplateAndSave,
      deletePage,
      deletePageAndSave,
      getAllPages,
      updatePackage,
      updateSection,
      updateSectionAndSave,
      updateAllSectionsAndSave,
      updateUSP,
      updateTestCard,
      duplicatePageAndSave,
      saveToServer,

      loading,
      pageLoading,
      hasError,
      pageNotFound,
      isPageContentLoaded,
      loadPageIfNeeded: fetchPageIntoState,
      saving
    }}>
      {children}
    </CMSContext.Provider>
  );
};
